import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as ProductSearch from './ProductSearch';
import * as PricingCalculator from './PricingCalculator';
import * as CustomerSearch from './CustomerSearch';
import * as OrderPlannerContact from './OrderPlannerContact';
import * as OrderPlannerDelivery from './OrderPlannerDelivery';
import * as OrderPlannerProducts from './OrderPlannerProducts';
import * as OrderPlannerSubmit from './OrderPlannerSubmit';
import * as PriceMatrix from './PriceMatrix';
import * as CheckIn from './CheckIn';
import * as Home from './Home';
import * as NavMenu from './NavMenu';
import * as UserEnabled from './UserEnabled';
import SalesGoals from '../components/sales/SalesGoals';

export default function configureStore(history, initialState) {
  const reducers = {
    productSearch: ProductSearch.reducer,
    pricingCalculator: PricingCalculator.reducer,
    customerSearch: CustomerSearch.reducer,
    orderPlannerContact: OrderPlannerContact.reducer,
    orderPlannerDelivery: OrderPlannerDelivery.reducer,
    orderPlannerProducts: OrderPlannerProducts.reducer,
    orderPlannerSubmit: OrderPlannerSubmit.reducer,
    priceMatrix: PriceMatrix.reducer,
    checkIn: CheckIn.reducer,
    home: Home.reducer,
    navMenu: NavMenu.reducer,
    salesGoals: SalesGoals.reducer,
    userEnabled: UserEnabled.reducer
  };

  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js